import { myUploadsSearchSchema } from '@/hooks/queries/uploads/useUploadToS3'
import {
  ASSORTMENTS_CSV_UPLOAD_TYPES,
  CORE_CSV_UPLOAD_TYPES,
  LAUNCHES_CSV_UPLOAD_TYPES,
  MATERIALS_CSV_UPLOAD_TYPES,
} from '@repo/csv'
import { createFileRoute } from '@tanstack/react-router'
import { MyUploadsTable } from './-components/MyUploadsTable'

// Operations uploads: core + the assortment / launches / materials app types.
const APP_MY_UPLOAD_TYPES = [
  ...CORE_CSV_UPLOAD_TYPES,
  ...ASSORTMENTS_CSV_UPLOAD_TYPES,
  ...LAUNCHES_CSV_UPLOAD_TYPES,
  ...MATERIALS_CSV_UPLOAD_TYPES,
] as const

export const Route = createFileRoute('/_auth/_modules/_app/my-uploads/')({
  component: MyUploadsPage,
  validateSearch: (search) => myUploadsSearchSchema.parse(search),
})

function MyUploadsPage() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  return (
    <MyUploadsTable
      module="core"
      uploadTypes={APP_MY_UPLOAD_TYPES}
      allUploadsPermission="upload_allUploads_view"
      search={search}
      navigate={navigate}
      onOpenUpload={(scope, fileName) =>
        navigate({ to: '/my-uploads/$scope/$fileName', params: { scope, fileName } })
      }
    />
  )
}
